<template>
    <h3 v-html="$t('TEXT_CONTACT_US_FORM_HEADER')" ref="formRef"></h3>
    <p><span>＊</span>{{ $t('TEXT_REQUIRED_FIELD') }}</p>

    <div class="p-contact__information">
        <dl>
            <dt><span class="icon"><img src="@/assets/img/ui_parts/svg/attention_icon_contact.svg" alt="！" /></span>{{
                $t('LABEL_PLEASE_CONFIRM') }}</dt>
            <dd>{{ $t('TEXT_CONTACT_US_FORM_1') }}</dd>
        </dl>
    </div>
        <!-- post -->
        <section class="article-content">
            <h3 class="read">hubsynchをご利用いただき、ありがとうございます。</h3>
            <p>hubsynchに関してのお問合せは、下記『個人情報の取扱いについて』に同意の上、入力フォームにお名前・ご連絡先・お問合せ内容などをご記入ください。折り返し担当者からご連絡いたします。なお、営業目的のお問合せには、回答できかねる場合もございます。あらかじめご了承ください。
            </p>
            <p>※&nbsp;hubsynch（ハブシンク）は、決済マネージメントサービスとなります。<br>決済以外のご利用サービス詳細（商品内容や配送状況等）についてはお答えできかねますので、ご利用サービスのカスタマーセンターへお問合せください。
            </p>
            <p><br></p>
            <div class="contact-area">
                <h3 class="read">【各種メールが未着のお客様へ】</h3>
                <p>各携帯会社において、迷惑メール対策が強化されておりますので、迷惑メール対策で受信拒否設定やドメイン指定をされている方は、お手数ですがご利用の前に以下のドメインからのメールを受信できるよう設定を行ってください。
                </p>
                <h5>【よくある原因】</h5>
                <ul>
                    <li>RFC違反メールアドレスを使用している。</li>
                    <p> 　・ケース1：アットマーク(@)の直前やメールアドレスの先頭にピリオド (.) がある<br><br>
                        　 　【例】abcd.@example.co.jp<br><br>
                        　 　【例】.abcd@example.co.jp<br><br>
                        　 ・ケース2：アットマーク（@）より前で、ピリオド (.) が連続している<br><br>
                        　 　【例】abcd..@example.co.jp<br><br>
                        　 　【例】ab..cd@example.co.jp<br><br>
                        　 ・ケース3：半角英数字と一部の記号※以外の文字列を含んでいる<br><br>
                        　 　　※一部の記号（. ! # $ % &amp; ‘ * + – / = ? ^ _ { | } ~ ）<br><br>
                        　 　【例】ab[cd@example.co.jp<br><br>
                        　 　【例】ab@cd@example.co.jp<br><br>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(注意)ただし、@の前の部分全体を「”」で囲んでいる場合は許可される場合もあります。</p>
                    <li>Yahoo!メールやGmail等のフリーメールアドレスをご利用されている方は、迷惑メールに分類されている場合がございますので、「迷惑メールフォルダ」をご確認ください。</li>
                    <li>au・docomoをご利用の方は、「受信拒否設定 ⇒ 解除」や「迷惑メールおまかせ規制 ⇒ 規制しない」、「なりすまし規制設定 ⇒ 低」に設定してください。<br><br>
                        ※設定方法がわからない場合は、携帯電話各社ホームページやサポートセンター、もしくは携帯ショップまでお問合せいただきますようお願いいたします。<br><br>
                        ※設定が難しい場合は、大変お手数ですがパソコンアドレスでご登録いただきますよう、お願いいたします。</li>
                    <li>登録されたメールアドレスが間違っている可能性がございます。ご登録情報のご確認をお願いいたします。</li>
                    <li>受信メールボックスの容量がいっぱいになっている場合がございます。受信メールフォルダ、ごみ箱フォルダの整理をしてください。</li>
                    <li>インターネットの途中経路の障害や、お客様のご利用されているメールサーバの問題等による遅配・未配につきましては、当社ではその責を一切負いません。<br><br>
                        ※購入履歴､振込先情報は｢マイページ」からもご確認いただけます｡メールが届かない場合には必ず「マイページ」をご確認ください。</li>
                    <li>iCloudのメールアドレスを使用している。</li>
                </ul>
                <p>iCloud関連のメールアドレス（@icloud.com等）は迷惑メール判定のフィルターが厳しく、迷惑メールフォルダにも入らずに削除されてしまう事例があります。<br><br>
                    そのため、上記メールアドレスをご使用予定の場合はお手数をおかけしますが、別のメールアドレスのご利用をご検討くださいますよう、よろしくお願いいたします。
                </p>
            </div>
            <p><br></p>
            <div class="contact-kiyaku-wrap scroll-box">
                <div class="kiyaku-box">
                    <h2>1. 個人情報の収集について</h2>
                    <p>当社では、個人に関する以下の情報を収集させていただきます。</p>
                    <ol>
                        <li>お問合せいただく方の社名、氏名、電話番号、メールアドレス</li>
                    </ol>
                    <h2>2. 個人情報の利用目的について</h2>
                    <p>当社は、お問合せフォームにてご提供いただいた個人情報は、以下の目的のみに使用いたします。</p>
                    <ol>
                        <li>お問合せに対する回答</li>
                    </ol>
                    <h2>3. 提供いただいた個人情報の任意性および当該情報を与えられなかった場合について</h2>
                    <p>個人情報をいただけない場合は、お問合せに対する回答を連絡することができません。</p>
                    <h2>4. 個人情報の第三者提供・開示について</h2>
                    <p>当社では、次の場合を除き、収集した個人情報を2項記載の目的の範囲を超えて当該個人の同意を得ずに第三者提供・開示することはありません。</p>
                    <ol>
                        <li>法令に基づく場合</li>
                        <li>人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
                        <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要である場合であって、本人の同意を得ることが困難であるとき</li>
                        <li>国の機関若しくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがあるとき
                        </li>
                    </ol>
                    <h2>5. 廃棄・消去について</h2>
                    <p>ご提供いただいた個人情報は、お問合せの件が解決次第、当社の責任において廃棄・消去いたします。</p>
                    <h2>6. 開示・訂正・利用停止・削除について</h2>
                    <p>ご提供いただいた個人情報の利用目的の通知、開示・訂正・追加・削除、利用停止・消去をご希望される場合は、７項の個人情報相談窓口までご連絡ください。</p>
                    <h2>7. 個人情報相談窓口</h2>
                    <p>
                        hubsynch株式会社　個人情報お客様対応窓口メールアドレス：support@hubsynch.com
                    </p>
                    <h2>8. 個人情報保護管理者</h2>
                    <p>hubsynch株式会社 代表取締役 沖津 貴俊</p>
                    <p></p>
                </div>
            </div>
        </section>

    <div class="p-contact__btn p-contact__btn--input">
        <div class="c-btn c-btn--contact-confirm"><input id="btn-agree" v-on:click="agree" type="submit"
                value="同意する"></div>
    </div>
</template>

<script setup>
import { useContactUsStore } from "@/stores/contactUsStore";
import { useUserStore } from "@/stores/userStore";
import { useCompanyAppStore } from "@/stores/companyAppStore";
import { onBeforeMount, ref } from "vue";

const contactUsStore = useContactUsStore();
const companyAppStore = useCompanyAppStore();
const userStore = useUserStore();

onBeforeMount(async () => {    
    if (contactUsStore.isLoggedIn) {
        await companyAppStore.getActiveRegisteredMerchants();

        const userInfo = await userStore.getAccountInfo();
        contactUsStore.params.last_name = userInfo.last_name;
        if (userStore.isOverseasUser) {
            contactUsStore.params.last_name = null;
        }
        contactUsStore.params.first_name = userInfo.first_name;
        contactUsStore.params.phone_number = userInfo.tel;
        contactUsStore.params.email = userInfo.email;
    }
});

function agree() {
    contactUsStore.step = "input";
}
</script>